module.exports = __webpack_public_path__ + "static/media/tnt.32b44795.svg";